import * as React from 'react';
import * as main from "../../main.module.scss";
export const Points = () => {
  return (
    <section className={main.hugs}>
      <div className="container">
        <div className={`${main.container} ${main.orange}`}>
          <h2 className={main.title}>Мастер-класс для родителей, которым знаком хотя бы один из этих пунктов:</h2>
          <ul className={main.listTriple}>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/forparents_01.png" alt=""/>
              <p>Ребёнок не&nbsp;может выбрать специализацию</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/forparents_02.png" alt=""/>
              <p>Ребёнок выбрал, но,&nbsp;возможно, не&nbsp;справится</p>
            </li>
            <li>
              <img src="https://fs.advance.ru/landing-pages/webinar/kids_career/forparents_03.png" alt=""/>
              <p>Ребёнок выбрал&nbsp;то, с&nbsp;чем вы&nbsp;не&nbsp;согласны и&nbsp;считаете бесперспек&shy;тивным</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
